import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
import { gql } from "apollo-angular";

import {
  GetAllBuyMovDocument,
  UpdateBuyMovDocument,
  DischargeBuyMovDocument,
  SearchBuyDocument,
  RemoveBuyMov,
} from "./schema.graphql";
import {
  GetAllBuyMovQueryVariables,
  GetAllBuyMovQuery,
  UpdateBuyMovMutation,
  UpdateBuyMovMutationVariables,
  DischargeBuyMovMutation,
  DischargeBuyMovMutationVariables,
  SearchBuyQuery,
  SearchBuyMovQueryVariables,
  RemoveBuyMovMutation,
  RemoveBuyMovMutationVariables,
} from "src/app/model/buymov";

@Injectable({
  providedIn: "root",
})
export class GetAllBuyMovGQL extends Apollo.Query<
  GetAllBuyMovQuery,
  GetAllBuyMovQueryVariables
> {
  document = GetAllBuyMovDocument;
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: "root",
})
export class UpdateBuyMovGQL extends Apollo.Mutation<
  UpdateBuyMovMutation,
  UpdateBuyMovMutationVariables
> {
  document = UpdateBuyMovDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: "root",
})
export class DischargeBuyMovGQL extends Apollo.Mutation<
  DischargeBuyMovMutation,
  DischargeBuyMovMutationVariables
> {
  document = DischargeBuyMovDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: "root",
})
export class RemoveBuyMovGQL {
  constructor(private apollo: Apollo.Apollo) {}

  updateBuyMov(buyMovId: string) {
    return this.apollo.mutate<
      RemoveBuyMovMutation,
      RemoveBuyMovMutationVariables
    >({
      mutation: RemoveBuyMov,
      variables: { buyMovId },
    });
  }
}

@Injectable({
  providedIn: "root",
})
export class SearchBuyGQL extends Apollo.Query<
  SearchBuyQuery,
  SearchBuyMovQueryVariables
> {
  document = SearchBuyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
